import { render } from "./PpcBAProductMarginCell.vue?vue&type=template&id=387410ac"
import script from "./PpcBAProductMarginCell.vue?vue&type=script&lang=js"
export * from "./PpcBAProductMarginCell.vue?vue&type=script&lang=js"

import "./PpcBAProductMarginCell.vue?vue&type=style&index=0&id=387410ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__